import React from 'react';
import contensis from 'Common/api/contensis';
import cmsParser from 'Common/util/cmsParser';
import setCacheHeaders from 'Common/func/setCacheHeaders';
import { excludeMetadata } from 'Common/util/contensis/api';

import type { NextPageWithLayout, GetServerSideProps } from 'next';

import Metadata from 'Components/Metadata';
import MainLayout from 'Layout/Main';
import Template, { datamap, PageData } from 'Templates/International';

const International: NextPageWithLayout<PageData> = ({ entry, ancestors }) => {
    return (
        <>
            <Metadata {...cmsParser.metadata(entry)} />
            <Template {...datamap({ entry, ancestors })} />
        </>
    );
};

International.getLayout = (page, props) => {
    return <MainLayout {...props}>{page}</MainLayout>;
};

export const getServerSideProps: GetServerSideProps<any> = async ({ preview, res }) => {
    const { fetch, surrogateKeys } = contensis({ preview, fetchSurrogateKeys: true });
    const { data, error } = await fetch(async client => {
        const resPage = await client.nodes.get({
            path: `/international`,
            entryLinkDepth: 2,
            entryFields: ['*', ...excludeMetadata]
        });

        if (!resPage.entry) {
            return { error: true };
        }

        const ancestors = await client.nodes.getAncestors({
            id: resPage.id,
            entryFields: ['title']
        });

        return {
            entry: resPage.entry,
            ancestors
        };
    });

    if (error) {
        return { notFound: true };
    } else {
        setCacheHeaders(res, surrogateKeys);

        return { props: data };
    }
};

export default International;
